import { createVanIconComponent } from "./van"

const NewArrival = createVanIconComponent("new-arrival")
export default NewArrival
